import { Routes } from '@angular/router';
import { authGuard, loginGuard, superadminGuard } from './core/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CrudPageComponent } from './pages/crud-page/crud-page.component';
import { TerminalComponent } from './pages/terminal/terminal.component';
import { HolidayCalendarComponent } from './pages/holiday-calendar/holiday-calendar.component';
import { AttendanceReportComponent } from './pages/attendance-report/attendance-report.component';
import { AdminManagementComponent } from './pages/admin-management/admin-management.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'terminal', component: TerminalComponent },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'workers', component: CrudPageComponent, data: { resource: 'workers' } },
      { path: 'machines', component: CrudPageComponent, data: { resource: 'machines' } },
      { path: 'operations', component: CrudPageComponent, data: { resource: 'operations' } },
      { path: 'materials', component: CrudPageComponent, data: { resource: 'materials' } },
      { path: 'holidays', component: HolidayCalendarComponent },
      { path: 'assignments', component: CrudPageComponent, data: { resource: 'assignments' } },
      { path: 'attendance', component: CrudPageComponent, data: { resource: 'attendance' } },
      { path: 'production', component: CrudPageComponent, data: { resource: 'production' } },
      { path: 'approvals', component: CrudPageComponent, data: { resource: 'approvals' } },
      { path: 'approval-log', component: CrudPageComponent, data: { resource: 'approvalLog' } },
      { path: 'material-usage', component: CrudPageComponent, data: { resource: 'materialUsage' } },
      { path: 'attendance-report', component: AttendanceReportComponent },
      { path: 'admin-management', component: AdminManagementComponent, canActivate: [superadminGuard] }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
